@if (isLoading) {
<app-loading-spinner [text]="'Negotiations'"></app-loading-spinner>
} @if (lot$ | async; as data) {
<div class="py-2 px-4 page-height overflow-auto">
  <div class="px-7 py-5 my-2 mx-auto max-w-2xl">
    <mat-card
      appearance="outlined"
      class="my-card counter-card my-1 w-100 font-medium"
    >
      <mat-card-content class="my-1">
        <form [formGroup]="newNegotiation" (ngSubmit)="onSubmit()">
          <div
            class="flex flex-row gap-4 flex-wrap justify-center items-center"
          >
            <mat-form-field appearance="outline" formGroupName="cash_price">
              <mat-label>Price</mat-label>
              <input
                matInput
                type="number"
                formControlName="amount"
                placeholder="0.00"
              />
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Volume</mat-label>
              <input
                matInput
                type="number"
                formControlName="volume_value"
                placeholder="0"
              />
            </mat-form-field>
            <!-- Shipping Date Field -->
            <mat-form-field appearance="outline">
              <mat-label>Delivery Window</mat-label>
              <mat-date-range-input [rangePicker]="picker" [min]="minDate">
                <input
                  matStartDate
                  formControlName="ship_begin"
                  placeholder="Start date"
                  [errorStateMatcher]="matcher"
                />
                <input
                  matEndDate
                  formControlName="ship_end"
                  placeholder="End date"
                  [errorStateMatcher]="matcher"
                />
              </mat-date-range-input>
              <!-- <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint> -->
              <mat-datepicker-toggle
                matIconSuffix
                [for]="picker"
              ></mat-datepicker-toggle>
              <mat-date-range-picker touchUi #picker></mat-date-range-picker>
            </mat-form-field>
          </div>
        </form>
      </mat-card-content>
    </mat-card>
  </div>
  <div class="px-7 py-5 my-2 mx-auto max-w-2xl">
    <div class="flex justify-between items-center text-center px-3">
      <div class="text-gray-400 text-xl font-medium text-white">
        {{ data.commodity }}
        @if (data.product_type) { - {{ data.product_type }}
        } -
        {{ data.grade }}
      </div>
      <div
        class="text-gray-400 text-xs flex justify-center items-center text-center"
      >
        <span class="text-center">Originated As</span>
        <mat-chip-set class="flex flex-row pl-2 items-start text-xs">
          <mat-chip
            style="margin-left: 4px !important"
            disableRipple="true"
            [ngClass]="{
              'blue-chip': data.lot_type === 'Offer',
              'green-chip': data.lot_type === 'Bid'
            }"
          >
            {{ data.lot_type }}
          </mat-chip>
        </mat-chip-set>
      </div>
    </div>
    <div class="my-4">
      <mat-card class="my-card text-white my-4 px-4 w-full">
        <mat-card-content class="w-full">
          <div class="px-2 w-full">
            <div
              id="details-grid"
              class="my-2 w-full grid grid-cols-2 text-left justify-center"
            >
              <div class="tablet-max:text-sm text-base text-gray-300">
                Origin
              </div>
              <div class="font-medium">{{ data.origin }}</div>
              <div class="tablet-max:text-sm text-base text-gray-300">
                Specifications
              </div>
              <div class="font-medium">
                @for (spec of data.specifications; track spec) { @if (spec.value
                !== '') {
                <span> {{ spec.title }} - {{ spec.value }} <br /> </span>
                } }
              </div>
              <div class="font-base tablet-max:text-sm text-base text-gray-300">
                Price
              </div>
              <div class="font-medium">
                {{ data.currency }}
                $ {{ data.price | priceType }}
                /
                {{ data.units === "Metric Tonnes" ? "MT" : data.units }}
              </div>
              <div class="tablet-max:text-sm text-base text-gray-300">
                Volume
              </div>
              <div class="font-medium">
                {{ data.volume_value | number }}
                {{ data.units === "Metric Tonnes" ? "MT" : data.units }}
              </div>
              <div class="tablet-max:text-sm text-base text-gray-300">
                Delivery Type
              </div>
              <div class="font-medium">
                {{ data.delivery_type }}
              </div>
              <div class="tablet-max:text-sm text-base text-gray-300">
                Location
              </div>
              <div style="text-wrap: wrap" class="font-medium">
                {{ data.destination }}
              </div>
              <div class="tablet-max:text-sm text-base text-gray-300">
                Shipping
              </div>
              <div class="font-medium">
                <div>
                  {{ data.ship_begin | date : "MMM d, y" }} -
                  {{ data.ship_end | date : "MMM d, y" }}
                </div>
              </div>
              <div class="tablet-max:text-sm text-base text-gray-300">
                Rules to Govern
              </div>
              <div class="font-medium">
                {{ data.rules_to_govern }}
              </div>
              <div class="tablet-max:text-sm text-base text-gray-300">
                Grades/Weights to Govern
              </div>
              <div class="font-medium">
                {{ data.weight_grade_to_govern }}
              </div>
              <div class="tablet-max:text-sm text-base text-gray-300">
                Container Tpe
              </div>
              <div class="font-medium">
                {{ data.container_type }}
              </div>
              <div class="tablet-max:text-sm text-base text-gray-300">
                Payment terms
              </div>
              <div class="font-medium">
                {{ data.payment_term }}
              </div>
              <div
                class="tablet-max:text-sm text-base text-gray-300"
                style="border-color: transparent"
              >
                Additional Notes
              </div>
              <div class="font-medium" style="border-color: transparent">
                {{ data.additional_info || "-" }}
              </div>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
      <div class="absolute bottom-4 left-0 right-0 flex justify-center">
        <button
          class="button-transition bg-custom-blue text-white text-md p-4 rounded-full flex items-center justify-center w-40"
          type="submit"
          (click)="onSubmit()"
          [style.opacity]="buttonOpacity"
        >
          Submit
        </button>
        <!-- </a> -->
      </div>
    </div>
  </div>
  <div class="h-16"></div>
</div>
}
